import { Link } from "@tanstack/react-router";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      aria-label="SafePlate home"
      className="inline-flex items-center gap-3 text-stone-950 no-underline"
      to="/"
    >
      <span className="grid size-9 place-items-center rounded-xl bg-emerald-900 text-sm font-black text-white shadow-sm">
        SP
      </span>
      {compact ? null : (
        <span className="text-[1.05rem] font-black tracking-[-0.035em]">
          SafePlate
        </span>
      )}
    </Link>
  );
}
